import { playersIndicated } from "../playersIndicated";
export const indicated = playersIndicated.filter(
  (player) => player.jogo === "VALORANT"
);
